import './OpentypeFeatures.scss';

import type { FC } from 'react';

import ColorBar from 'components/ColorBar';

interface Props {
  features: {
    id: number;
    name: string;
    image: { url: string | null };
  }[];
}

export const OpentypeFeatures: FC<Props> = (props) => {
  const { features } = props;

  if (features.length === 0) {
    return null;
  }

  return (
    <ColorBar>
      <div className="OpentypeFeatures content-wrapper">
        <h2>Features</h2>

        <div className="OpentypeFeatures-grid">
          {features.map((feature) => {
            if (feature.image.url == null) {
              return null;
            }

            return (
              <div key={feature.id} className="OpentypeFeatures-grid-item">
                <img
                  src={feature.image.url}
                  className="OpentypeFeatures-grid-item-image"
                  loading="lazy"
                  decoding="async"
                />

                <div className="OpentypeFeatures-grid-item-title">
                  {feature.name}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </ColorBar>
  );
};

export default OpentypeFeatures;
